// src/composables/useTableRest.js
import { ref, computed, getCurrentInstance } from "vue";

export function useTableRest(opts = {}, deps = {}) {
  const totalRows = ref(null);
  const offset = ref(0);
  const loading = ref(false);
  const page = ref(1);
  const data = ref([]);
  const lastfilter = ref("");
  const lasturl = ref(null);
  const err = ref(null);

  async function getTotalRows(filter, cleanFilters = false) {
    try {
      lastfilter.value = JSON.stringify(filter);
      if (removeLimit) lasturl.value = replaceLimit(lasturl.value);

      const targetUrl = removeOffset(cleanFilters ? url : lasturl.value );
      const r = await rest.get({ url: targetUrl, params: { getTotal: true } });

      const doc = r?.data?.doc ?? r?.data?.data?.[0];
      totalRows.value = parseInt(doc?.total);
    } catch (e) {
      console.error(e);
      totalRows.value = null;
    }
  }

  const {
    url,
    getLimit = 25,
    order,
    apiversion = "2",
    getLimitByDropDown = null,
    removeLimit = false,  
    rest
  } = opts;


  const filtersRef = deps.filtersRef || null;

  // ---------- COMPUTED ----------
  const effectiveLimit = computed(() =>
    getLimitByDropDown == null ? getLimit : getLimitByDropDown
  );

  const totalPages = computed(() => {
    if (!totalRows.value || effectiveLimit.value <= 0) return 1;
    return Math.max(1, Math.ceil(totalRows.value / effectiveLimit.value));
  });

  // ---------- HELPERS ----------
  function removeOffset(rawUrl) {
    let urlCopy = typeof rawUrl === "string" ? rawUrl : String(rawUrl ?? "");
    const startIndex = urlCopy.indexOf("offset=");
    if (startIndex !== -1) {
      const endIndex = urlCopy.indexOf("&", startIndex + 1);
      urlCopy = endIndex === -1
        ? urlCopy.slice(0, Math.max(0, startIndex - 1))
        : urlCopy.slice(0, startIndex) + urlCopy.slice(endIndex + 1);
    }
    return urlCopy;
  }

  function replaceLimit(rawUrl) {
    return (rawUrl || "").replace(/limit=[^&]*&?/, "");
  }

  function resetToFirstPage() {
    page.value = 1;
    offset.value = 0;
  }

  

  function setPage(newPage) {
    if (newPage === page.value) return;
    loading.value = true;
    page.value = newPage;
    offset.value = (page.value - 1) * effectiveLimit.value;
    getData();
  }

  async function getData(cleanFilters = false) {
    try {
      loading.value = true;

      let search;
      if (cleanFilters === false) {
        search =
          apiversion === "1"
            ? await filtersRef.value.getFiltersV1()
            : await filtersRef.value.getFiltersV2();
      } else  {
        search = {};
      }

      const query = { ...search };
      query.limit = effectiveLimit.value;
      query.offset = offset.value;
      if (order) query.order = order;

      const getOptions = { url, params: query };
      const r = await rest.get(getOptions);

      let rows;
      const containNotificante = r.data.data.find(
        (item) => item.Nombre === "Notificante - Departamental"
      );
      if (containNotificante) {
        rows = r.data.data.filter(
          (item) => item.Nombre !== "Notificante - Departamental"
        );
      } else {
        rows = r.data.data;
      }

      for (let i in rows) {
        rows[i].index = parseInt(i);
      }
      
      data.value = rows;
      lasturl.value = r.request.responseURL;

      getTotalRows(search, cleanFilters);

      let backToTheFirstPage = false;
      if (lastfilter.value === '{"search":"{}"}') backToTheFirstPage = true;
      if (cleanFilters) backToTheFirstPage = true;

      // if (backToTheFirstPage) {
      //   resetToFirstPage();
      // }

      if (backToTheFirstPage) {
        await document.getElementById("DTid").childNodes[16].childNodes[1].click();
      }

      err.value = false;
      loading.value = false;
    } catch (e) {
      console.error(e);
      loading.value = false;
    }
  }

  function downloadXls() {
    if (!lasturl.value) return;
    const glue = lasturl.value.includes("?") ? "&" : "?";
    window.location.assign(`${lasturl.value}${glue}getXLS`);
  }

  return {
    // state
    totalRows,
    offset,
    loading,
    page,
    data,
    lastfilter,
    lasturl,
    err,
    totalPages,

    // actions
    getData,
    getTotalRows,
    setPage,
    resetToFirstPage,
    downloadXls,
  };
}